import { StyleRules } from '@material-ui/core/styles';
import { TablePaginationClassKey } from '@material-ui/core/TablePagination';

import { core as theme } from '../styles/core';

export const MuiTablePagination: Partial<StyleRules<TablePaginationClassKey>> = {
  input: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 4,
  },
  select: {
    color: theme.palette.grey[600],
    paddingBottom: 4,
    paddingTop: 4,
  },
  selectRoot: {
    marginLeft: 20,
    marginRight: 40,
  },
  caption: {
    color: theme.palette.grey[600],
    fontWeight: 500,
  },
  actions: {
    '& > button.Mui-disabled': {
      color: theme.palette.grey[500],
    },
    '& > button': {
      color: theme.palette.grey[700],
    }
  }
};
